// extracted by mini-css-extract-plugin
export default {"TableBody":"rdlc_TableBody__Y1KSW"};